module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Photo Credits and Graphic Design")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Melanie Gillis Photography, Hamilton, Ontario, Canada")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Paul Wallace, Orangeville, Ontario, Canada")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("F-Stop Foto and Frame, Orangeville, Ontario, Canada")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Contributors")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Carl Capuano and the Rise Again Band, Geoff Saxon, Jeff Belrose, Lynne Mellor, Joffrey Bernabe, Jennifer Millett, Jessica Buscher and Rosanna Camposarcone Airhardt.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0